import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase env vars missing (REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY). ' +
    'Auth will fall back to legacy JWT mode.'
  );
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

// Expose the client on window for Playwright E2E session injection.
// Production-guarded: this branch is dead-code-eliminated by CRA's build.
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production' && supabase) {
  window.__supabase = supabase;
}
